module.exports = __webpack_public_path__ + "static/media/hero-bg.01813f09.png";